import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
  historicLabel?: string
  optional?: boolean
  prefix?: string
}

const YearsMonths = ({ historicLabel, optional, prefix, ...rest }: Props) => {
  return (
    <div className="mb-6">
      <label className="block mt-1">
        <span className="inline-block text-base-text mb-1">
          {historicLabel}{' '}
          {optional && (
            <span className="text-xs lowercase whitespace-nowrap">
              (optional)
            </span>
          )}
        </span>
      </label>
      <div className="grid lg:grid-cols-4 grid-cols-2 md:grid-cols-3 gap-4">
        <TextInput unpadded name={`${prefix}years`} label="Years" {...rest} />
        <TextInput unpadded name={`${prefix}months`} label="Months" {...rest} />
      </div>
    </div>
  )
}

export default YearsMonths
